'use client';

import {
  DefaultError,
  useMutation,
  UseMutationOptions,
} from '@tanstack/react-query';
import { toast } from 'sonner';
import { AxiosError } from 'axios';

export const useApiMutation = <
  TData = unknown,
  TError = DefaultError & AxiosError,
  TVariables = void,
  TContext = unknown,
>(
  options: UseMutationOptions<TData, TError, TVariables, TContext>,
) => {
  const handleJWTExpiration = (error: TError) => {
    const axiosError = error as AxiosError;

    if (axiosError.response?.status.toString().startsWith('5')) {
      toast.error('Something went wrong. Please try again later.');
    }
    if (axiosError.response?.status.toString().startsWith('4')) {
      toast.error(
        (axiosError?.response?.data as { message: string })?.message ||
          'Something went wrong. Please try again later.',
      );
    }
  };

  return useMutation({
    ...options,
    onError(error, ...rest) {
      handleJWTExpiration(error);
      options.onError?.(error, ...rest);
    },
  });
};
